import axios from "axios";
import { API_URL } from "@/config";

const store = {
  namespaced: true,

  actions: {
    async getInstitutionSettingsForInstitution(_, institutionId) {
      const res = await axios.get(`${API_URL}/institutionSettings/institution/${institutionId}`);

      if (!res.data) {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },
  },
};

export default store;
